const arabicImages = {
  afnan: require('./arabics/afnan.jpeg'),
  armaf: require('./arabics/armaf.webp'),
  lattafa: require('./arabics/lattafa.png'),
  'al haramain': require('./arabics/al_haramain.png'),
  bharara: require('./arabics/bharara.webp'),
  orientica: require('./arabics/orientica.webp'),
  rasasi: require('./arabics/rasasi.webp')
};

export default arabicImages;
